// External libraries
import gql from 'graphql-tag';

export const SUGGESTED_DEFAULT_LANGUAGES_QUERY = gql`
  query SuggestedDefaultLanguagesQuery(
    $countryCode: CountryCodes!
    $languageCode: CheckoutContentLanguageCode!
  ) {
    localeMetadata {
      territories(countryCode: $countryCode, languageCode: $languageCode) {
        code
        suggestedDefaultLanguage
      }
    }
  }
`;
